import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditorModule } from 'primeng/editor';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { QCRejectReasonDialogConfig, QCRejectReasonDialogResult } from './model';

/**
 * A reusable dialog component for entering QC rejection reasons.
 * Uses a rich text editor (p-editor) for input.
 * Opens via DynamicDialogService.
 */
@Component({
    selector: 'app-qc-reject-reason-dialog',
    standalone: true,
    imports: [CommonModule, EditorModule, FormsModule, ButtonModule],
    template: `
        <div class="modal-body py-2">
            <p-editor [style]="{ height: '320px' }" [(ngModel)]="reason" />
        </div>

        <div class="d-flex justify-content-end gap-2 mt-3">
            <p-button
                label="取消"
                (onClick)="onCancel()"
                [text]="true"
                styleClass="p-button-text p-button-secondary"
            />
            <p-button
                label="确定"
                (onClick)="onConfirm()"
                [text]="true"
                [disabled]="!reason"
                styleClass="p-button-text p-button-danger"
            />
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QCRejectReasonDialogComponent {
    reason = '';

    protected readonly ref = inject(DynamicDialogRef, { optional: true });

    private readonly _dialogConfig = inject<DynamicDialogConfig<QCRejectReasonDialogConfig>>(DynamicDialogConfig);

    constructor() {
        const config = this._dialogConfig.data;
        if (config?.initialReason) {
            this.reason = config.initialReason;
        }
    }

    onConfirm(): void {
        const result: QCRejectReasonDialogResult = {
            confirmed: true,
            reason: this.reason,
        };
        this.ref?.close(result);
    }

    onCancel(): void {
        const result: QCRejectReasonDialogResult = {
            confirmed: false,
        };
        this.ref?.close(result);
    }
}
